export const RadioGroupProps = (formik: any, name: string) => ({
  value: formik.values[name],
  setValue: formik.setFieldValue,
  setTouched: formik.getFieldHelpers(name).setTouched,
  error: formik.touched[name] ? formik.errors[name] : undefined,
})
